// Error404Page.tsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  Stack,
  Box,
  Divider,
  Typography,
  TextField,
  InputAdornment,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  IconButton,
  LinearProgress,
  CircularProgress,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "../index.css";

export default function Error404Page() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);

  // Cerrar el modal con Escape
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Buscar: ${query}`);
  };

  return (
    <div className="error404" data-page="404">
      {/* Cabecera / Hero */}
      <section className="hero">
        <p className="hero__eyebrow">Error</p>
        <h1 className="hero__title" aria-label="404 Página no encontrada">
          404
        </h1>
        <p className="hero__subtitle">Ups… la página que buscas no existe o fue movida.</p>

        <div className="hero__actions">
          <button className="btn btn--primary" onClick={() => navigate(-1)}>
            ← Volver
          </button>
          <Link className="btn" to="/">
            Ir al inicio
          </Link>
          <button className="btn btn--outline" onClick={() => setOpen(true)}>
            Abrir diálogo
          </button>
        </div>

        <form className="search" onSubmit={onSubmit}>
          <input
            className="input"
            type="text"
            placeholder="Buscar…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            aria-label="Buscar"
          />
          <button className="btn" data-variant="neutral">
            Buscar
          </button>
        </form>
      </section>

      {/* Zona de práctica */}
      <section className="playground">
        <div className="card">
          <h2 className="card__title">Elementos para practicar estilos</h2>

          <div className="grid">
            <div className="box">
              <label className="label">Campo de texto</label>
              <input className="input" placeholder="Escribe algo…" />
            </div>

            <div className="box">
              <label className="label">Checkboxes</label>
              <label className="check">
                <input type="checkbox" /> Recordarme
              </label>
              <label className="check">
                <input type="checkbox" defaultChecked /> Acepto términos
              </label>
            </div>

            <div className="box">
              <label className="label">Radios</label>
              <label className="radio">
                <input type="radio" name="opt" defaultChecked /> Opción A
              </label>
              <label className="radio">
                <input type="radio" name="opt" /> Opción B
              </label>
            </div>

            <div className="box">
              <label className="label">Select</label>
              <select className="select">
                <option>Selecciona…</option>
                <option>Uno</option>
                <option>Dos</option>
                <option>Tres</option>
              </select>
            </div>

            <div className="box">
              <label className="label">Badges</label>
              <span className="badge" data-tone="info">
                info
              </span>
              <span className="badge" data-tone="success">
                nuevo
              </span>
              <span className="badge" data-tone="warning">
                beta
              </span>
              <span className="badge" data-tone="danger">
                error
              </span>
            </div>

            <div className="box">
              <label className="label">Alertas</label>
              <div className="alert" data-tone="info">
                Esto es una alerta informativa.
              </div>
              <div className="alert" data-tone="success">
                Operación completada con éxito.
              </div>
              <div className="alert" data-tone="warning">
                Atención: acción irreversible.
              </div>
              <div className="alert" data-tone="danger">
                Error: algo salió mal.
              </div>
            </div>

            <div className="box">
              <label className="label">Botonera</label>
              <div className="button-row">
                <button className="btn">Default</button>
                <button className="btn btn--primary" data-variant="primary">
                  Primary
                </button>
                <button className="btn btn--outline" data-variant="outline">
                  Outline
                </button>
                <button className="btn btn--ghost" data-variant="ghost">
                  Ghost
                </button>
                <button className="btn btn--danger" data-variant="danger">
                  Danger
                </button>
                <button className="btn btn--icon" aria-label="info">
                  <span role="img" aria-hidden>
                    ℹ️
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        {" "}
        <div className="box">
          <label className="label">Progreso</label>
          <progress className="progress" value={60} max={100} />
        </div>
      </section>
    </div>
  );
}
